export enum ConsoleModal {
  PROFILE = "profile",
  USER_ROLE_INFO = "role-info",
  WORKFLOW_TYPES = "workflow"
}
